import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    general: 'General',
    items: 'Items',
    options: 'Options',
  },
  fr: {
    general: 'Général',
    items: 'Éléments',
    options: 'Options',
  },
});

export default locales;
